import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  // Memoise the redirect state so <Navigate> doesn't receive a fresh object
  // reference on every render (breaks memoisation on downstream consumers).
  const navState = useMemo(() => ({ from: loc.pathname }), [loc.pathname]);
  if (loading) return <div className="p-10 text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" state={navState} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
